import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import { Form  } from "semantic-ui-react";
import { AddBtn } from "../../../commonComponents/AddBtn";
import { FormTitle } from "../../../commonComponents/FormTitle";
import List from "../../../commonComponents/List";
import PaymentDetails from "./paymentDetails";
import { CustomLoader } from "../../../commonComponents/formComponents/loader";
import { useDocument } from "../../hooks/useDocument";
import { TranslateContext } from "../TranslateContext";

 const Payment=()=> {
  const {isLoading,AddItem,deleteItem,updateItem,saveItem}=useDocument({actionType:"PARTIES",tableName:"paymentList",containerKey:"headerParties"})
   
   const isFormEnabled=false
    const paymentList = useSelector((state) => state.Actor.paymentList);
    const translate = React.useContext(TranslateContext).translate;

   
    const renderItem=useCallback((item)=>{
     return  <PaymentDetails
     key={item.infoId}
     item={item}
     isFormEnabled={isFormEnabled}
     updateData={updateItem}
     deleteData={deleteItem}
     saveData={saveItem}
     />
    },[isFormEnabled,updateItem,deleteItem])
    return (
   
        <Form.Group className="float-container">
          <FormTitle title={translate("PAYMENT_DETAILS", {ns:["default", "parties"]})}></FormTitle>
          <List renderItem={renderItem}
            dataSource={paymentList} 
          />
  
        
      { isLoading && <CustomLoader /> }
      <AddBtn disabled={isFormEnabled} onClick={AddItem} text={`Add ${translate("VAT_PAYER", {ns:["default", "parties"]})}`}>

      </AddBtn>
    
   
        </Form.Group>
     
    );
  }
  
  export default React.memo(Payment)
